import React from 'react'
import css from './style.scss'
import {n, abbr} from 'shared/numbers'

export default (props)=>(
  <div className={css.accountInfo}>
    <div className={css.avatar}>
      <img alt='avatar' src={props.picture ? props.picture : "/assets/placeholder/normal.png"}/>
    </div>
    <div className={css.text}>
      <h3>{props.name}</h3>
      <span>{props.info.followers_count > 1000 ? abbr(props.info.followers_count) : n(props.info.followers_count)} Followers</span>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/adventures/public/accountInfo.js